module.exports = __webpack_public_path__ + "img/kosherhalal.f273513d.jpeg";